// extracted by mini-css-extract-plugin
export default {"wifiFooter":"styles_wifiFooter__JdSnr","fullView":"styles_fullView__wLN5k","shimmer":"styles_shimmer__ETrxB"};